import { Mapping, Resource } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { removeMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeMapping';

// use useRemoveResource() since it also
// clears the diagram and closes drawers if necessary
export const removeResource = (data: Resource) => (model: Model) => {
  const mappingDataArray = model.linkDataArray.filter(
    (linkData): linkData is Mapping =>
      isMapping(linkData) && linkData.from === data.key
  );
  // do not mutate linkDataArray while iterating through linkDataArray
  mappingDataArray.forEach((data) => {
    removeMapping(data)(model);
  });

  model.removeNodeData(data);
};
